import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

export const CommonRoutes = [
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      title: 'Profile',
    },
    component: () => import('../views/common/Profile.vue'),
  },
  {
    // Open to every signed-in user (CommonUsers, below): setting up the computer you are sitting at
    // needs no administrator. It is reached from a row on the Profile page. The auth service limits how many codes one person may issue.
    path: '/setup-this-computer',
    name: 'Install ReGov Toolkit',
    meta: {
      title: 'Install ReGov Toolkit',
    },
    component: () => import('../views/common/SetupThisComputer.vue'),
  },
  {
    path: '/profile/settings',
    name: 'User Settings',
    meta: {
      title: 'Settings',
    },
    component: () => import('../components/common/profile-settings/index.vue'),
  },
  {
    path: '/profile/webauthn',
    name: 'User Passwordless Registration',
    meta: {
      title: 'Profile',
    },
    component: () => import('../components/common/UserRegWebAuthN.vue'),
  },
  {
    path: '/dependency-list',
    name: 'Auto Created Dependencies',
    meta: {
      title: 'Profile',
    },
    component: () => import('../components/common/ImportAutoCreatedDependencyList.vue'),
  },
  {
    path: '/profile/wkst',
    name: 'WKST Profile',
    meta: {
      title: 'Settings',
    },
    component: () => import('../components/common/profile-settings/WorkstationSetting.vue'),
  },
  {
    path: '/profile/printer-settings',
    name: 'Printer Settings',
    meta: {
      title: 'Settings',
    },
    component: () => import('../components/common/profile-settings/PrinterSetting.vue'),
  },
];

CommonRoutes.forEach((element, index) => {
  CommonRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria(authRoles.CommonUsers, next);
  };
});

export default CommonRoutes;
